import React, { useCallback, useRef } from 'react';
import AddFundingRate from './AddFundingRate';
import { AgGridReact } from 'ag-grid-react';
import FundingRatesGrid from '../../../components/agGrid/FundingRatesGrid/FundingRatesGrid';

const FundingRates = () => {
  const gridRef = useRef<AgGridReact>(null);
  const onCreate = useCallback(() => {
    if (gridRef?.current?.api) {
      gridRef.current.api.refreshServerSide({ purge: true });
    }
  }, []);
  return (
    <div>
      <AddFundingRate onCreate={onCreate} />
      <FundingRatesGrid ref={gridRef} />
    </div>
  );
};

export default FundingRates;
